import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ImageQuery from '../shared/ImageQuery';

const e = React.createElement;

const StyledGraphicContainer = styled.div.attrs(({ ...props }) => e(props))`
  min-height: ${({ initialHeight }) => `${initialHeight}px`};
  display: flex;
  flex-direction: column;

`;
const Graphic = ({ mP, mL, tP, tL, d, l, maxWidth, marginBottom, initialHeight, styles }) => (
  <StyledGraphicContainer  initialHeight={initialHeight}>
    <ImageQuery className="mobile" src={mP} maxWidth={maxWidth} marginBottom={marginBottom} styles={styles} />
    <ImageQuery className="mobileLandscape" src={mL} maxWidth={maxWidth} marginBottom={marginBottom} styles={styles} />
    <ImageQuery className="tabletPortrait" src={tP} maxWidth={maxWidth} marginBottom={marginBottom} styles={styles} />
    <ImageQuery className="tabletLandscape" src={tL} maxWidth={maxWidth} marginBottom={marginBottom} styles={styles} />
    <ImageQuery className="desktop" src={d} maxWidth={maxWidth} marginBottom={marginBottom} styles={styles} />
    <ImageQuery className="larger" src={l} maxWidth={maxWidth} marginBottom={marginBottom} styles={styles} />
  </StyledGraphicContainer>
);

Graphic.propTypes = {
  /**  mobile portrait */
  mP: PropTypes.string,
  /**  mobile landscappe */
  mL: PropTypes.string,
  /**  tablet portrait */
  tP: PropTypes.string,
  /**  tablet landscape */
  tL: PropTypes.string,
  /**  desktop */
  d: PropTypes.string,
  /**  larger devices */
  l: PropTypes.string,
  maxWidth: PropTypes.number,
  styles: PropTypes.array,
};

Graphic.defaultProps = {
  mP: '',
  mL: '',
  tP: '',
  tL: '',
  d: '',
  l: '',
  maxWidth: null,
  styles: [],
};

export default Graphic;
